export default class Video {

    constructor (videoObj) {
        this.initVideo(videoObj);
    }

    initVideo (videoObj) {
        this.videoContainer = videoObj;
        this.toggleBtn = videoObj.querySelector('[data-player="toggle"]');
        this.preview = videoObj.querySelector('[data-player="preview"]');
        this.video = videoObj.querySelector('[data-player="video"]');

        this.isPlaying = false;
        this.isPaused = true;

        this.bindEvents();
    }

    bindEvents () {
        this.toggleBtn.addEventListener('click', (e) => {

            if (!this.isPlaying) {
                if (this.preview && !this.preview.classList.contains('is-gone')) {
                    this.removePreview();
                    this.playVideo();
                } else {
                    this.playVideo();
                }
            } else if (!this.isPaused) {
                this.pauseVideo();
            }
        });

        this.video.addEventListener('ended', (e) => {
            this.isPlaying = false;
            this.isPaused =  true;
            this.toggleBtn.classList.remove('is-playing');
        });
    }

    removePreview () {
        this.preview.classList.remove('is-visible');
        this.preview.addEventListener('transitionend', (e) => {
            this.preview.classList.add('is-gone');
            // this.videoContainer.removeChild(this.preview);
        });
    }

    pauseVideo () {
        this.video.pause();
        this.isPlaying = false;
        this.isPaused =  true;
        this.toggleBtn.classList.remove('is-playing');
        // console.log("isPlaying: " + this.isPlaying, "isPaused: " + this.isPaused);
    }

    playVideo () {
        this.video.play();
        this.isPlaying = true;
        this.isPaused =  false;
        this.toggleBtn.classList.add('is-playing');
        // console.log("isPlaying: " + this.isPlaying, "isPaused: " + this.isPaused);
    }

}



// WEBPACK FOOTER //
// ./lib/video.js